import React from 'react';

export default function Loader({ hidden }) {
  return (
    <div className={`loader-overlay ${hidden ? 'hidden' : ''}`}>
      {/* Ambient glow */}
      <div
        className="ambient-glow"
        style={{
          width: 300,
          height: 300,
          background: 'radial-gradient(circle, rgba(59,130,246,0.15) 0%, transparent 70%)',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      />

      <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 24 }}>
        {/* Infinity-inspired logo */}
        <svg width="56" height="28" viewBox="0 0 56 28" fill="none">
          <path
            d="M14 14C14 8.477 18.477 4 24 4C27.5 4 30.6 5.8 32.5 8.5L28 14L32.5 19.5C30.6 22.2 27.5 24 24 24C18.477 24 14 19.523 14 14Z"
            stroke="#3b82f6"
            strokeWidth="1.5"
            fill="none"
          />
          <path
            d="M42 14C42 19.523 37.523 24 32 24C28.5 24 25.4 22.2 23.5 19.5L28 14L23.5 8.5C25.4 5.8 28.5 4 32 4C37.523 4 42 8.477 42 14Z"
            stroke="#3b82f6"
            strokeWidth="1.5"
            fill="none"
          />
        </svg>

        <div className="loader-ring" />

        <p
          style={{
            fontSize: 10,
            fontFamily: 'Inter, sans-serif',
            fontWeight: 500,
            letterSpacing: '0.4em',
            textTransform: 'uppercase',
            color: 'rgba(59,130,246,0.7)',
          }}
        >
          INFINITI FX35
        </p>
      </div>
    </div>
  );
}
